/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Credits_Load_FailedInputs */

const en_settings_credits_load_failed = /** @type {(inputs: Settings_Credits_Load_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to load credit balance`)
};

const es_settings_credits_load_failed = /** @type {(inputs: Settings_Credits_Load_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to load credit balance`)
};

/**
* | output |
* | --- |
* | "Failed to load credit balance" |
*
* @param {Settings_Credits_Load_FailedInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const settings_credits_load_failed = /** @type {((inputs?: Settings_Credits_Load_FailedInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Credits_Load_FailedInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_credits_load_failed(inputs)
	return es_settings_credits_load_failed(inputs)
});